/**
 * ss-touch-fix.js — Ghost overlay cleanup. Scroll lock lives in ss-scroll-lock.js.
 */
(function () {
  'use strict';

  function unlockDrawerScroll() {
    var body = document.body;
    if (!body || body.dataset.ssDrawerScrollLocked !== '1') return;
    if (document.documentElement.classList.contains('ss-scroll-locked')) return;
    var y = parseInt(body.dataset.ssDrawerScrollY || '0', 10) || 0;
    body.style.position = '';
    body.style.top = '';
    body.style.width = '';
    if (!document.querySelector('.ss-qv.is-open')) {
      body.style.paddingRight = '';
    }
    delete body.dataset.ssDrawerScrollLocked;
    delete body.dataset.ssDrawerScrollY;
    window.scrollTo(0, y);
  }

  function clearGhosts() {
    var body = document.body;
    var html = document.documentElement;
    if (!body) return;

    var drawerOpen = document.querySelector('details.ss-drawer[open]');

    document.querySelectorAll('.ss-qv').forEach(function (el) {
      el.style.removeProperty('pointer-events');
    });

    if (window.matchMedia('(min-width: 990px)').matches && !drawerOpen) {
      unlockDrawerScroll();
      body.classList.remove('ss-drawer-open');
      html.classList.remove('ss-drawer-open');
    }

    var portal = document.getElementById('ss-drawer-portal');
    if (portal && (!drawerOpen || window.matchMedia('(min-width: 990px)').matches)) {
      portal.hidden = true;
      portal.setAttribute('aria-hidden', 'true');
      portal.style.removeProperty('pointer-events');
    }

    if (typeof window.ssSyncScrollLock === 'function') window.ssSyncScrollLock();
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn, { once: true });
    } else {
      fn();
    }
  }

  onReady(function () {
    clearGhosts();
    setTimeout(clearGhosts, 400);
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) clearGhosts();
  });

  window.addEventListener('pageshow', clearGhosts);
  window.addEventListener('resize', function () {
    if (window.matchMedia('(min-width: 990px)').matches) clearGhosts();
  }, { passive: true });

  window.ssClearScrollGhosts = clearGhosts;
})();
